import React from "react";
import cx from "classnames";
import { withLDConsumer } from "ldclient-react";

import { compose } from "../../../../utils/fp";

import analytics, { events } from "../../../../utils/analytics";
import env from "../../../../utils/env";

import {
  formatPrice,
  wrapWithParens,
  prependText,
  addCurrency
} from "../utils/helperFuncs";

import Grouping from "./grouping";

import "./Product.css";
import fallback from "./fallback.svg";

const CustomizeProduct = props => {
  const {
    exploreDisplay,
    questionId,
    grouping,
    isSelect,
    title,
    extraChoicePrice,
    open,
    image,
    isSharedBox,
    isProspect,
    flags
  } = props;

  const titleStyle = cx({
    "lh-lg": true,
    "fs-16": true,
    "ff-ns": true,
    "pad-h-4": true,
    "case-caps": true,
    "fw-normal": true
  });

  const priceStyle = cx({
    price: true,
    "lh-md": true,
    "fw-normal": true,
    "ff-ns": true,
    "c-black-60": true,
    "pad-h-4": true,
    customize: true,
    "fs-16": true
  });

  const lockIconStyle = cx({
    fal: true,
    "c-black-60": true,
    "fa-lock-alt": !isSelect,
    "fa-lock-open-alt": isSelect,
    "fs-16": true
  });

  const priceWithCurrency = compose(
    addCurrency,
    formatPrice
  );

  const formatAddonPrice = compose(
    wrapWithParens,
    prependText("+"),
    priceWithCurrency
  );

  //Display Containers
  const questionIdDisplay = () => (
    <div className="ff-ns fw-bold fs-16 lh-lg">
      {prependText("Customization ")(questionId)}
    </div>
  );

  const canEditQuestion = () => {
    if(isSharedBox) {
      return false;
    }
    return (
      open &&
      questionId &&
      (grouping !== Grouping.SELECT ||
        (grouping === Grouping.SELECT && isSelect))
    );
  };

  return (
    <div className="d-flex product pad-8">
      <div>
        <img className="product-thumb" src={image || fallback} alt={title} />
      </div>
      <div className="d-flex flex-aic pad-8">
        <div className="d-flex flex-fdc">
          {!exploreDisplay && questionIdDisplay()}

          {/* Product Title */}
          <div className={titleStyle}>{title}</div>

          {/* Additional Choice price display */}
          {extraChoicePrice && !exploreDisplay && (
            <div className={priceStyle}>
              {formatAddonPrice(extraChoicePrice)}
            </div>
          )}

          {/* Select Label Unlocked */}
          {grouping === Grouping.SELECT && (
            <div className="select-text d-flex fw-bold fs-16 ff-ns">
              <i className={lockIconStyle} />
              <span className="ff-ns">Select Only</span>
            </div>
          )}

          {canEditQuestion() && !isProspect && (
            <div className="pad-h-4 ff-ns">
              <a
                onClick={() => {
                  analytics.track(events.CLICKED_ELEMENT, {
                    element_name: "Edit",
                    option_title: `Customize - ${title}`
                  });
                }}
                href={`${env.envURL}/${
                  flags.customizeV2MyBox ? "customize-v2" : "customize"
                }/?q=${questionId}`}
              >
                Edit
              </a>
            </div>
          )}

          {/* Upgrade to Unlock */}
          {!exploreDisplay && !canEditQuestion() && open && !isSharedBox && (
            <div className="pad-h-4 ff-ns">
              <a
                onClick={() => {
                  analytics.track(events.CLICKED_ELEMENT, {
                    element_name: "Upgrade",
                    option_title: "Upgrade to Unlock - Customization Upgrade"
                  });
                }}
                href={`${env.envURL}/upgrade-confirmation`}
              >
                Upgrade to Unlock
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default withLDConsumer()(CustomizeProduct);



// WEBPACK FOOTER //
// ./src/Components/Panels/SharedComponents/Product/CustomizeProduct.js